(() => {
  if (customElements.get('hx-announcement-marquee')) return;
  customElements.define('hx-announcement-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.rows = [...this.querySelectorAll('[data-news-index]')];
      this.index = this.rows.findIndex(row => row.classList.contains('is-active'));
      this.toggle = this.querySelector('.hx-news-toggle');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.toggleAttribute('data-paused', this.motion.matches);
      this.toggle.addEventListener('click', () => { this.toggleAttribute('data-paused'); this.schedule(); }, options);
      this.updateVisibility = () => { this.toggleAttribute('data-suspended', document.hidden); this.schedule(); };
      document.addEventListener('visibilitychange', this.updateVisibility, options);
      this.motion.addEventListener('change', () => { this.toggleAttribute('data-paused', this.motion.matches); this.schedule(); }, options);
      this.updateVisibility();
      this.setAttribute('data-ready', '');
    }
    schedule() {
      clearTimeout(this.timer);
      const paused = this.hasAttribute('data-paused');
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.resume : this.toggle.dataset.pause);
      if (paused || this.hasAttribute('data-suspended')) return;
      this.timer = setTimeout(() => {
        this.index = (this.index + 1) % this.rows.length;
        this.rows.forEach((row, i) => {
          row.classList.toggle('is-active', i === this.index);
          row.setAttribute('aria-hidden', String(i !== this.index));
          row.inert = i !== this.index;
        });
        this.schedule();
      }, 3000);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; clearTimeout(this.timer); }
  });
})();
